import { TOOL_NAMES } from './workflows'
import { priceInvSaveSignal } from './signal-bridge'

/**
 * 常驻工具注册（不依赖任何组件实例，App 启动时注册一次、永不注销）
 *
 * WAIT_DRAWER_SAVE_RESULT 必须常驻：保存成功后 drawerV2 随即被 onCancel 销毁，
 * 若注册在组件 toolRegister 内，SDK 解析本步骤时工具可能已被 unregister，
 * 会误报 wait-timeout。工具本身只依赖 signal-bridge，无需组件上下文。
 */
export function registerPersistentTools(ai) {
  if (!ai || !ai.registry) return

  ai.registry.register({
    name: TOOL_NAMES.WAIT_DRAWER_SAVE_RESULT,
    description: 'Wait for the save result',
    skipDefaultVisualFeedback: true,
    // 用户点击 Confirm 只是开始：点击后的任何失败（校验未通过 / 取消弹窗 /
    // 排期超限 / 接口报错）都由 drawerV2 在发生瞬间 record，本步骤立即定音
    // 失败并回传真实原因；成功同理。不存在"等用户补填"的挂起态，超时纯防接口悬挂
    handle: async () => {
      // 55s < 步骤 timeout 60s < 父侧失联 watchdog 90s：
      // 超时先走本工具的可读文案，而不是被 SDK/父侧硬杀成笼统错误
      const result = await priceInvSaveSignal.wait(
        55000,
        'Timed out waiting for the save response from the server'
      )
      if (!result.success) {
        return { success: false, error: result.error || 'Save failed' }
      }

      return { saved: true }
    }
  })
}
